import axios from "axios";
import { toast } from "react-toastify";
import {
  USERVENDORLIST_SUCCESS,
  USERLIST_SUCCESS,
  IS_LOADING,
  USER_DETAIL_SUCCESS,
  USER_VERIFICATION_SUCCESS,
  BANK_VERIFICATION_SUCCESS,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
  PROFILE_UPDATE_SUCCESS,
  PROFILE_UPDATE_ERROR,
  VENDOR_CREATE_ERROR,
  VENDOR_CREATE_SUCCESS,
  THEME_UPDATE_SUCCESS,
  THEME_UPDATE_ERROR,
  VENDOR_THEME_CUSTOMIZATION,
  USER_BALANCE_API_SUCCESS,
  USER_BALANCE_API_ERROR,
  JOIN_API_SUCCESS,
  JOIN_API_ERROR,
  DEPOSIT_API_SUCCESS,
  DEPOSIT_API_ERROR,
} from "./Type";
import { apiHeader } from "./ApiHeader";
import "react-toastify/dist/ReactToastify.css";
import { baseUrlPostGres } from "../constant";
import HandleError from "../HandleError";
import { apiVersion } from "src/utils/apiVersion";

toast.configure();

export const GetUserVendorListAction = (page, size, typ, data /*searchname*/) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/uservendorList?page=${page}&size=${size}&typ=${typ}`, data, {
      headers: apiHeader(),
    })

    .then((response) => {
      dispatch({
        type: USERVENDORLIST_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      console.log("user list error", errors);
    });
};

export const CreateVendorProfileAction = (data) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/vendor/create`, data, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: VENDOR_CREATE_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: VENDOR_CREATE_ERROR,
        payload: errors,
      });
    });
};

export const GetUserListAction = (page, size, typ, data, searchname) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  axios
    // .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/list?page=${page}&size=${size}&typ=${typ}&searchname=${searchname}`, {
    //     headers: apiHeader()
    // })

    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/userList?page=${page}&size=${size}&typ=${typ}&searchname=${searchname}`, data, {
      headers: apiHeader(),
    })

    .then((response) => {
      dispatch({
        type: USERLIST_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      console.log("user list error", errors);
    });
};

export const FetchUserDetailAction = (data) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/view`, data, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: USER_DETAIL_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      console.log("user list error", errors);
    });
};

export const FetchVendorThemeAction = (data) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/get-theme-customization`, data, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: VENDOR_THEME_CUSTOMIZATION,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      console.log("user list error", errors);
    });
};

export const UserDetailAction = (id) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  console.log("id called", id);
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/customer_detail`, id, {
      headers: apiHeader(true),
    })
    .then((response) => {
      dispatch({
        type: USER_DETAIL_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      console.log("user Detail error", errors);
    });
};

export const AcceptRejectAction = (data) => (dispatch) => {
  dispatch({ type: IS_LOADING });

  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/active-inactive`, data, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: USER_VERIFICATION_SUCCESS,
        payload: response,
      });
      toast.success(response.data.message, { theme: "colored" });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      console.log("user Detail error", errors);
    });
};

export const BankVerificationUpdate = (data) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/bank_verified`, data, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: BANK_VERIFICATION_SUCCESS,
        payload: response,
      });
      toast.success(response.data.message, { theme: "colored" });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      console.log("user Detail error", errors);
    });
};

export const ResetBankVerificationUpdate = (data) => (dispatch) => {
  dispatch({
    type: BANK_VERIFICATION_SUCCESS,
    payload: {},
  });
};

export const UpdatePasswordAction = (data) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/change_password`, data, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: CHANGE_PASSWORD_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: CHANGE_PASSWORD_ERROR,
        payload: errors,
      });
    });
};

export const ResetUpdatePasswordAction = () => (dispatch) => {
  dispatch({
    type: CHANGE_PASSWORD_SUCCESS,
    payload: {},
  });
};

export const UpdateProfileAction = (data) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/update_profile`, data, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: PROFILE_UPDATE_SUCCESS,
        payload: response,
      });
      var data = localStorage.getItem("security_auth");
      var decodeProfileData = JSON.parse(data);
      decodeProfileData["name"] = response.data.data.userdeatail.name;
      if (response.data.data.userdeatail.profilepic) {
        decodeProfileData["profile_img"] = response.data.data.userdeatail.profilepic;
      }
      localStorage.setItem("security_auth", JSON.stringify(decodeProfileData));
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: PROFILE_UPDATE_ERROR,
        payload: errors,
      });
    });
};
export const updateThemeCustomization = (data) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/theme-customization`, data, {
      headers: apiHeader(),
    })
    .then((response) => {
      dispatch({
        type: THEME_UPDATE_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: THEME_UPDATE_ERROR,
        payload: errors,
      });
    });
};

export const currentBalanceApi = (URL, data) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(`${URL}`, data)
    .then((response) => {
      dispatch({
        type: USER_BALANCE_API_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: USER_BALANCE_API_ERROR,
        payload: errors,
      });
      console.log("user list error", errors);
    });
};
export const JoinGameApi = (URL, data) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(`${URL}`, data)
    .then((response) => {
      dispatch({
        type: JOIN_API_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: JOIN_API_ERROR,
        payload: errors,
      });
      console.log("user list error", errors);
    });
};
export const Depositapi = (URL, data) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  await axios
    .post(URL, data)
    .then((response) => {
      dispatch({
        type: DEPOSIT_API_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      dispatch({
        type: DEPOSIT_API_ERROR,
        payload: errors,
      });
      console.log("user list error", errors);
    });
};

export const ResetUpdateProfileAction = () => (dispatch) => {
  dispatch({
    type: PROFILE_UPDATE_SUCCESS,
    payload: {},
  });
};

export const GetVendorDetailAction = (id) => (dispatch) => {
  dispatch({ type: IS_LOADING });
  console.log("id called", id);
  axios
    .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/vendor_detail`, id, {
      headers: apiHeader(true),
    })
    .then((response) => {
      //console.log("response", response);
      dispatch({
        type: USER_DETAIL_SUCCESS,
        payload: response,
      });
    })
    .catch((errors) => {
      HandleError(errors.response.data);
      console.log("user Detail error", errors);
    });
};


 export const UpdateVendorStatusAction = (data, callback) => async (dispatch) => {
  dispatch({ type: IS_LOADING });
  try {
    const response = await axios.post(
      `${baseUrlPostGres()}/admin/${apiVersion.v1}/users/vendor/status`, // replace this URL if your API is different
      data,
      { headers: apiHeader() }
    );
    toast.success(response.data.message || "Status updated successfully", {
      theme: "colored",
    });
    if (callback) callback(); // used to refresh the list after update
  } catch (errors) {
    HandleError(errors.response?.data);
    console.error("Status update error", errors);
  }
};
